import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./style.scss";
import { getOrderByOrderStatusID } from "services/user/orderService";
import { PacmanLoader } from "react-spinners";
import ModalReview from "component/user/modal_review";
import { getAllOrders } from "services/user/orderService";
import { Formatter } from "utils/formatter";
import { MdOutlinePendingActions } from "react-icons/md";
import {
  FaBoxOpen,
  FaShippingFast,
  FaTimesCircle,
  FaHandshake,
  FaHourglassHalf,
} from "react-icons/fa";
const OrderStatus = () => {
  const [modal, setModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({
    orderID: null,
    itemID: null,
  });
  const toggleModal = (orderID, itemID) => {
    setSelectedOrder({ orderID, itemID });
    setModal((prev) => !prev);
  };
  const { status } = useParams();
  const [selectedStatus, setSelectedStatus] = useState(status || "all");
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [refreshFetchOrders, setRefreshFetchOrders] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const renderIcon = (status) => {
    switch (status) {
      case "Chờ xác nhận":
        return <MdOutlinePendingActions />;
      case "Đang đóng gói":
        return <FaBoxOpen />;
      case "Đang vận chuyển":
        return <FaShippingFast />;
      case "Đã giao":
        return <FaHandshake />;
      case "Đã hủy":
        return <FaTimesCircle />;
      case "Chờ thanh toán":
        return <FaHourglassHalf />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        let orderStatusID;
        if (selectedStatus === "pending") orderStatusID = 1;
        else if (selectedStatus === "packaging") orderStatusID = 2;
        else if (selectedStatus === "shipping") orderStatusID = 3;
        else if (selectedStatus === "completed") orderStatusID = 4;
        else if (selectedStatus === "canceled") orderStatusID = 6;
        if (orderStatusID !== undefined) {
          try {
            setIsLoading(true);
            const data = await getOrderByOrderStatusID(
              token,
              orderStatusID,
              currentPage
            );
            setOrders(data.data.content);
            setTotalPages(data.data.page.totalPages);
          } finally {
            setIsLoading(false);
          }
        } else {
          try {
            setIsLoading(true);
            const response = await getAllOrders(token, currentPage);
            console.log("Fetched orders:", response);
            setOrders(response.data.content);
            setTotalPages(response.data.page.totalPages);
          } finally {
            setIsLoading(false);
          }
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, [selectedStatus, currentPage, token, refreshFetchOrders]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Cuộn mượt
    });
  };

  const renderPagination = () => {
    const totalButtonsToShow = 5; // Số nút muốn hiển thị (bao gồm trang hiện tại)
    const pages = [];
    const startPage = Math.max(
      0,
      currentPage - Math.floor(totalButtonsToShow / 2)
    );
    const endPage = Math.min(
      totalPages - 1,
      startPage + totalButtonsToShow - 1
    );

    // Hiển thị trang đầu tiên và nút "..."
    if (startPage > 0) {
      pages.push(0); // Trang đầu tiên
      if (startPage > 1) {
        pages.push("..."); // Dấu "..."
      }
    }

    // Hiển thị các trang xung quanh trang hiện tại
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    // Hiển thị nút "..." và trang cuối cùng
    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        pages.push("..."); // Dấu "..."
      }
      pages.push(totalPages - 1); // Trang cuối cùng
    }

    return pages;
  };

  const handleTabClick = (key) => {
    setSelectedStatus(key);
    navigate(`/order-status/${key}`); // Cập nhật URL
  };

  return (
    <div className="order-status-container">
      {/* Tabs trạng thái */}
      <div className="status-tabs">
        {[
          { key: "all", label: "Tất cả đơn" },
          // { key: "refunding", label: "Chờ hoàn tiền" },
          { key: "pending", label: "Chờ xác nhận" },
          { key: "packaging", label: "Đang đóng gói" },
          { key: "shipping", label: "Đang vận chuyển" },
          { key: "completed", label: "Đã giao" },
          { key: "canceled", label: "Đã hủy" },
        ].map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTabClick(tab.key)}
            className={selectedStatus === tab.key ? "active" : ""}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Danh sách đơn hàng */}
      <div className="order-list">
        {orders.length > 0 ? (
          orders.map((order) => {
            return (
              <div key={order.orderID} className="order-item">
                {/* <div className="status-icon d-flex align-items-center"> */}
                <span className="status-name">{order.orderStatus}</span>
                <span className="status-icon">
                  {" "}
                  {renderIcon(order.orderStatus)}
                </span>
                <div className="items-list">
                  {order.items.map((item) => (
                    <div key={item.bookID} className="item">
                      <img
                        src={item.imageLink}
                        alt={item.title}
                        className="item-image"
                      />
                      <p className="item-name">{item.title}</p>
                      <p className="order-status-quantity">
                        Số lượng: {item.quantity}
                      </p>

                      {order.orderStatus === "Đã giao" ? (
                        item.hasReview ? (
                          <button
                            className="mt-0 view-reviewed-btn ms-auto"
                            disabled
                          >
                            Bạn đã đánh giá
                          </button>
                        ) : (
                          <button
                            className="mt-0 view-details-btn ms-auto"
                            onClick={() => toggleModal(order.orderID, item.id)}
                          >
                            Đánh giá
                          </button>
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  ))}
                </div>
                <p className="order-status-total-price">
                  Tổng đơn hàng: {Formatter(order.totalPrice)}
                </p>
                <div className="order-buttons">
                  {/* Nút "Xem chi tiết" ở đầu */}
                  <button
                    className="view-details-btn"
                    onClick={() =>
                      navigate("/order-details", {
                        state: { orderID: order.orderID },
                      })
                    }
                  >
                    Xem chi tiết đơn hàng
                  </button>

                  {order.orderStatus === "Chờ xác nhận" && (
                    <button
                      className="cancel-order-btn"
                      onClick={() => navigate("/cancel-order", {
                        state: { orderID: order.orderID, orderPaymentStatus: order.paymentStatus },
                      })
                    } 
                    >
                      Hủy đơn
                    </button>
                  )}
                </div>

                {modal && selectedOrder.orderID && selectedOrder.itemID && (
                  <ModalReview
                    orderID={selectedOrder.orderID}
                    orderItemID={selectedOrder.itemID}
                    onClose={(isRefresh = false) => {
                      setModal(false);
                      if (isRefresh) {
                        setRefreshFetchOrders((prev) => !prev);
                      }
                  }}  
                  />
                )}
              </div>
            );
          })
        ) : (
          <p>Không có đơn hàng nào ở trạng thái này.</p>
        )}
      </div>

      {/* Phân trang */}
      <div className="paginationn">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 0}
          className="pagination-arrow"
        >
          «
        </button>
        {renderPagination().map((page, index) =>
          typeof page === "number" ? (
            <button
              key={index}
              onClick={() => handlePageChange(page)}
              className={currentPage === page ? "active" : ""}
            >
              {page + 1}
            </button>
          ) : (
            <span key={index} className="pagination-ellipsis">
              ...
            </span>
          )
        )}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages - 1}
          className="pagination-arrow"
        >
          »
        </button>
      </div>

      {/* Loading */}
      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderStatus;
